/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import HeaderCloseBar from './header/HeaderCloseBar';

const HeaderCloseBarNode = ({
  action,
  headerCloseBarRef,
  isFullscreen,
  isCloseBarAnimationAvailable,
  showCloseBar,
  ...props
}) => {
  //
  // const isCloseBarAnimationAvailable = false;
  // // フルスクリーン表示になる条件
  // const isFullscreen = inquiry.checkList.available && !state.desktop;

  // const headerCloseBarRef = useRef(null);
  // state
  // const [showCloseBar] = useState(false);

  const onClick = useCallback(
    event => {
      event.preventDefault();
      if (typeof action === 'function') {
        action.call(this);
      }
    },
    [action]
  );

  return (
    // header close bar - Fullscreen (Mobile w/Checkbox) only
    isFullscreen && (
      <HeaderCloseBar
        data-testid="HeaderCloseBar"
        ref={headerCloseBarRef}
        animation={isCloseBarAnimationAvailable}
        fixed={isFullscreen}
        hidden={!showCloseBar}
        onClick={onClick}
      />
    )
  );
};

export default HeaderCloseBarNode;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/HeaderCloseBarNode.js